<app-main-header></app-main-header>
<main>
    <router-outlet />
</main>
<app-footer></app-footer>
<p-confirmDialog></p-confirmDialog>